import { defineStore } from 'pinia'
import { ref } from "vue";
import { request } from "@/ts/request";
import { RequestStatus } from "@/ts/interfaces/requests/statusEnum";
import { userEditPathName } from "@/ts/apiRoutes";
import { UserServerData } from "@/ts/interfaces/requests/user";

export const useUpdateClientStore = defineStore('client-settings-edit',  () => {
    const status = ref<RequestStatus | null >(RequestStatus.INITIAL)

    async function edit(data: UserServerData) {
        const response = await request(userEditPathName, {
            method: 'PUT',
            body: JSON.stringify({
                ...data,
                email_notifications: data.email_notifications ? 1 : 0
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Content-type': 'application/json; charset=UTF-8'
            },
        })

        if(response.ok) {
            status.value = RequestStatus.SUCCESS
        }

        return response
    }

    return { status, edit }
})